var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExternal18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.003 5.452L10.435 9.02a1 1 0 0 1-1.415 0l-.04-.04a1 1 0 0 1 0-1.415l3.567-3.567H11a.999.999 0 0 1 0-1.998H15a1 1 0 0 1 1 1v4.002a.998.998 0 1 1-1.997 0v-1.55zM14 14v-3.008a1 1 0 1 1 2 0v3.003A2.004 2.004 0 0 1 13.995 16H3.999A1.999 1.999 0 0 1 2 14.002V4a2 2 0 0 1 2-2h3a1 1 0 0 1 0 2H4v10h10z",
    clipRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE0LjAwMyA1LjQ1MkwxMC40MzUgOS4wMmExIDEgMCAwIDEtMS40MTUgMGwtLjA0LS4wNGExIDEgMCAwIDEgMC0xLjQxNWwzLjU2Ny0zLjU2N0gxMWEuOTk5Ljk5OSAwIDAgMSAwLTEuOTk4SDE1YTEgMSAwIDAgMSAxIDF2NC4wMDJhLjk5OC45OTggMCAxIDEtMS45OTcgMHYtMS41NXpNMTQgMTR2LTMuMDA4YTEgMSAwIDEgMSAyIDB2My4wMDNBMi4wMDQgMi4wMDQgMCAwIDEgMTMuOTk1IDE2SDMuOTk5QTEuOTk5IDEuOTk5IDAgMCAxIDIgMTQuMDAyVjRhMiAyIDAgMCAxIDItMmgzYTEgMSAwIDAgMSAwIDJINHYxMGgxMHoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export { SvgExternal18 as ReactComponent };